import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import FormCotizaTuHibrido from "../cotizatuhibrido/FormCotizaTuHibrido";
const Footer = lazy(() => import('../footer/Footer'));
function CotizaTuHibrido(props) {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai te apoyamos. Revisa todos los modelos que tenemos para ti de acuerdo a tus necesidades. Puedes cotizar en línea"
        />
        <meta
          name="keywords"
          content="Hyundai, Grand i10, Accent, Ioniq, Creta, Tucson, Santa Fe"
        />
        <title>Cotiza tu Hyundai</title>
      </Helmet>
      <Menu />
      <FormCotizaTuHibrido datos={props} />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default CotizaTuHibrido;